import { collection, doc, getDocs } from 'firebase/firestore';
import { db } from '../config/firebase';

export type ProductId = 'vetaxis'|'staffaxis'|'noteaxis';

export type Entitlement = {
  plan: string;
  status: 'active'|'trialing'|'past_due'|'canceled'|'none';
  quantity?: number;
  trialEndsAt?: { toDate: () => Date } | null;
  trialExpired?: boolean;
};

export const fetchUserEntitlements = async (uid: string): Promise<Record<ProductId, Entitlement>> => {
  if (!db) return { vetaxis: { plan: 'none', status: 'none' }, staffaxis: { plan: 'none', status: 'none' }, noteaxis: { plan: 'none', status: 'none' } } as any;
  const base: Record<ProductId, Entitlement> = {
    vetaxis: { plan: 'none', status: 'none' },
    staffaxis: { plan: 'none', status: 'none' },
    noteaxis: { plan: 'none', status: 'none' },
  };
  const colRef = collection(doc(collection(db, 'entitlements'), uid), 'products');
  const snap = await getDocs(colRef);
  snap.forEach(d => {
    const data = d.data() as any;
    const pid = d.id as ProductId;
    base[pid] = {
      plan: data.plan || 'none',
      status: data.status || 'none',
      quantity: data.quantity,
      trialEndsAt: data.trialEndsAt || null,
      trialExpired: !!data.trialExpired,
    };
  });
  return base;
};

